import { isBefore } from 'date-fns';

import { confluenceLocalStorageInstance as localStorage, keys } from '@confluence/storage-manager';

/**
 *
 * Determines if iPuf needs to be suppressed
 */
export function isFumcSuppressed() {
	const item = localStorage?.getItem(keys.RECOMMENDED_STANDARD_DURING_PREMIUM_EOT_EXPIRY_DATE);
	return !!item && isBefore(Date.now(), Date.parse(item));
}
